export const state = {
  toastMessage: {
    toastId: '',
    msg: '',
    title: '',
    variant: '',
  },
}

export const actions = {
  setAlert({ commit }, param) {
    commit('setAlertMutation', param)
  },
  clearAlert({ commit }, param) {
    commit('clearAlertMutation', param)
  },
}

export const mutations = {
  clearAlertMutation(state, param) {
    // param.title = ''
    // param.msg = ''
    // param.variant = ''
    param.show = false
    param.hide = true
    state.toastMessage = { ...param }
  },
  setAlertMutation(state, param) {
    let randomID = String(Math.random(100))
    // this must be uniquely generate
    param.toastId = randomID
    param.show = true
    param.timeout = param.timeout || 5000
    param.position = param.position || 'b-toaster-top-right'
    param.variant = param.variant || 'info'
    state.toastMessage = param
  },
}

export const getters = {
  showToastMessage(state) {
    return state.toastMessage && state.toastMessage.show
  },
  getToast(state) {
    return state.toastMessage
  },
}
